import { ClipboardList } from "lucide-react";

import { AddTask } from "../../atomic-crm/tasks/AddTask";
import { TasksListByDueDate } from "../../atomic-crm/tasks/TasksListByDueDate";
import { EmptyState } from "../data-display/EmptyState";
import { GravunCard } from "../data-display/SectionCard";
import { ListPageHeader } from "../list/ListPageHeader";

/**
 * Workspace tasks, grouped by due date (overdue, today, tomorrow, this week,
 * later, recently done). Reuses Atomic's task logic, completion, editing and
 * the contact-aware create dialog all work against the real database.
 */
export const TasksPage = () => (
  <div className="mx-auto max-w-3xl">
    <ListPageHeader
      title="Tasks"
      subtitle="Follow-ups and to-dos across your workspace"
      actions={<AddTask selectContact display="chip" />}
    />
    <GravunCard className="px-5 py-4">
      <TasksListByDueDate
        emptyPlaceholder={
          <EmptyState
            icon={ClipboardList}
            title="No tasks yet"
            description="Create a follow-up task and it will show up here grouped by due date."
          />
        }
      />
    </GravunCard>
  </div>
);
